import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import ContextualMenu, { ContextualMenuButtons } from '../../components/ContextualMenu';
import DriveItemUtils from '../../utils/driveItem';
import { DriveItemInfo } from '../DriveItemList/reducer';
import { ContextualMenuItemType } from '../../components/ContextualMenu/constants';
import Utils from '../../utils';
import { Api } from '../../typings/api';
import { MenuItem, MenuItemType, CreateButtonOption } from '../../typings/menu';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList,
		proposalCreator: { fromTemplate: { customTemplatesIds } },
	} = state;
	const { contextualMenu } = driveList;
	const { isOpened } = contextualMenu;

	let driveItem: DriveItemInfo | undefined;
	let isDownloadable = false;
	let isUpdatable = false;
	let isDeletable = false;
	let isShareable = false;
	let isEditable = false;
	let isProposalCopyable = false;
	let isProposalNotCopyable = false;
	let isRenamable = false;
	let isDeletableFromAsp = false;
	let isCompatibleForTemplate = false;
	let isCustomTemplate = false;

	if (contextualMenu.isOpened) {
		const { driveItems } = driveList;
		const {
			downloadManager,
			galleryInfos: { config, template: { sharedMethods } },
			menuManager: { menuModes },
		} = state;
		const { driveItemId } = contextualMenu;
		driveItem = driveItems[driveItemId];
		const privateDirId = Utils.getPrivateDirId(driveList, config);

		if (driveItem) {
			// needed in the case an asset is deletedFromAsp while context menu is opened
			isDownloadable = DriveItemUtils.isDownloadable(driveItem, downloadManager, sharedMethods);
			isUpdatable = DriveItemUtils.isUpdatable(driveItem, downloadManager, sharedMethods);
			isDeletable = DriveItemUtils.isDeletable(driveItem, downloadManager);
			isShareable = DriveItemUtils.isShareable(sharedMethods);
			isEditable = DriveItemUtils.isEditable(driveItem);
			const isProposal = !!driveItem.format && DriveItemUtils.isProposal(driveItem.format as Api.PublicationFormat);
			const isDraftProposal = DriveItemUtils.isDraftProposal(driveItem);
			const isDeletableFromAspAssetType = !isProposal || isDraftProposal;
			const isPrivateDirDescendant = DriveItemUtils.isPrivateDirDescendant(driveItem.id, privateDirId, driveItems);
			const hasTemplatesOptionInCreateBtn = Object.values(menuModes).some(menuPosition => (
				menuPosition.some((menuItem: MenuItem) => (
					menuItem.type === MenuItemType.CreateButton &&
					menuItem.options!.includes(CreateButtonOption.proposalFromTemplate)
				))
			));

			isProposalCopyable = isProposal && !DriveItemUtils.isForbiddenForUpdateProposal(driveItem);
			isProposalNotCopyable = isProposal && DriveItemUtils.isForbiddenForUpdateProposal(driveItem);
			isRenamable = isPrivateDirDescendant;
			isDeletableFromAsp = isPrivateDirDescendant && isDeletableFromAspAssetType;
			isCompatibleForTemplate = hasTemplatesOptionInCreateBtn && DriveItemUtils.isValidResourceForProposal(driveItem);
			isCustomTemplate = customTemplatesIds.includes(driveItem.id);
		}
	}

	const buttons = isCustomTemplate
		? {
			[ContextualMenuItemType.RemoveTemplate]: true,
		}
		: {
			[ContextualMenuItemType.Download]: isDownloadable,
			[ContextualMenuItemType.Update]: isUpdatable,
			[ContextualMenuItemType.Delete]: isDeletable,
			[ContextualMenuItemType.Share]: isShareable,
			[ContextualMenuItemType.Edit]: isEditable,
			[ContextualMenuItemType.ProposalSaveAs]: isProposalCopyable,
			[ContextualMenuItemType.ProposalNoSaveAs]: isProposalNotCopyable,
			[ContextualMenuItemType.Rename]: isRenamable,
			[ContextualMenuItemType.DeleteFromAsp]: isDeletableFromAsp,
			[ContextualMenuItemType.SetAsTemplate]: isCompatibleForTemplate,
		} as ContextualMenuButtons;

	return { isOpened, driveItem, buttons };
};

export default connect(mapStateToProps)(ContextualMenu);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ContextualMenu/index.tsx